import { get } from 'lodash';
import { createSelector } from 'reselect';

import { suggestedDomainsErrorsSelector } from '../../../common/selectors/suggested-domains-selectors';
import { domainManagementErrorsSelector } from '../../../common/selectors/domain-management-selectors';
import { rightPaneAttributesSelector } from '../../../common/selectors/right-pane-selectors';

const formatErrorResponse = ( domainErrors ) => {
    let formattedDomainErrors = {};

    for( let [key, value] of Object.entries( domainErrors ) ){
        if( Array.isArray( value ) && value.length > 0 ){
            let formattedValue;
            if( typeof value[0] === 'object' ){
                formattedValue = value.map( domain => domain.domain );
            }
            else{
                formattedValue = value;
            }

            formattedDomainErrors[key] = formattedValue;
        }
    }

    return formattedDomainErrors;
};

export const manageBulkFormattedDomainErrorsSelector = createSelector(
    domainManagementErrorsSelector,
    ( domainErrors ) => formatErrorResponse( domainErrors )
);

export const allFormattedDomainErrorsSelector = createSelector(
    domainManagementErrorsSelector,
    suggestedDomainsErrorsSelector,
    ( domainErrors, suggestedDomainErrors ) => {
        // we don't need to do extra work to merge arrays because domain management & 
        // suggested domain actions happen independently of one another
        const allErrors = { ...domainErrors, ...suggestedDomainErrors };

        return formatErrorResponse( allErrors );
    }
);

export const domainActionTypeSelector = createSelector(
    rightPaneAttributesSelector, ( attributes ) => get( attributes, 'domainActionType', null )
);
